import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes'
import auth from './auth'
import Buefy from 'buefy'
import vueScrollBehavior from 'vue-scroll-behavior'
import 'buefy/dist/buefy.css'


Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(Buefy)

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  linkExactActiveClass: 'is-active',
  routes: routes
})

Vue.use(vueScrollBehavior, { router: router })

router.beforeEach((to, from, next) => {
  auth.loggedIn().then(function (isLogin) {
    if (isLogin || to.path == '/login') {
      next()
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  });
})

new Vue({ router }).$mount('#app')